import logo from "../../../assets/img/logo.svg";
import React from "react";
 

const BaseContainer = ({ title, children, style={}, displayLogo = true, additionClass = ""}) => {
 

  return (
    <div className={"setupContainer "+ additionClass}>
      { displayLogo && <img className={"logo-center"} src={logo} alt="TeachOn"/> }
      <h1 className={'H1 SECONDARY_70'}>
        { title }
      </h1>
      { children }
    </div>
  );
}

export default BaseContainer;
